<footer class="nsw-footer">
	<div class="nsw-footer__upper">
		<div class="nsw-container">
			<div class="nsw-footer__group">
				<div class="nsw-footer__heading">
					<a href="javascript:void(0)" class="footer-group-heading" routerLink="/whatIsBeachwatch">About Beachwatch</a>
				</div>
				<ul>
					<li><a class="footer-group-item" routerLink="/beachwatchPartners">How it works</a></li>
					<li><a class="footer-group-item" routerLink="/waterMonitoring">Why we monitor</a></li>
					<li><a class="footer-group-item" routerLink="/waterMonitoring/howWeMonitor">About the data we
							collect</a></li>
				</ul>
			</div>
			<div class="nsw-footer__group">
				<div class="nsw-footer__heading">
					<a href="javascript:void(0)" class="footer-group-heading">Resources</a>
				</div>
				<ul>
					<li>
						<a target="_blank" class="footer-group-item"
							[href]="NHMRC_PAGE_URL">
							Guidelines
						</a>
					</li>
					<li>
						<a target="_blank" class="footer-group-item"
							[href]="ABOUT_BEACHWATCH_PROTOCOL_URL">
							Beachwatch protocol
						</a>
					</li>
					<li>
						<a (mousedown)="navigateToStateOfBeaches()" target="_blank" class="footer-group-item"
							[href]="STATE_OF_BEACHES_REPORT_URL">
							State of the Beaches reports
						</a>
					</li>
					<li>
						<a class="footer-group-item" routerLink="/waterMonitoring/waterQualityData">Download the data</a>
					</li>
				</ul>
			</div>
			<div class="nsw-footer__group">
				<div class="nsw-footer__heading">
					<a href="javascript:void(0)" class="footer-group-heading">Help Beachwatch</a>
				</div>
				<ul>
					<li>
						<a class="footer-group-item" [routerLink]="['/contactUs']"
							[queryParams]="{ option : 'General Enquiry' }">
							Contact us
						</a>
					</li>
					<li><a class="footer-group-item" routerLink="reportPollution">Report pollution in New South Wales waterways</a>
					</li>
					<li>
						<a class="footer-group-item" [routerLink]="['/contactUs']"
							[queryParams]="{ option : 'Feedback' }">
							Give feedback on this site
						</a>
					</li>
				</ul>
			</div>
			<div class="nsw-footer__group">
				<div class="nsw-footer__heading" style="margin-bottom:0.25rem">
					<a href="javascript:void(0)" class="footer-group-heading">Connect with us</a>
				</div>
				<div style="display:flex;gap:10px;">
					<a target="_blank" [href]="BEACHWATCH_TWITTER_URL">
						<img src="assets/images/home/twitter.svg" alt="Twitter" width="24px" height="24px" />
					</a>
					<a target="_blank" [href]="BEACHWATCH_FACEBOOK_URL">
						<img src="assets/images/home/facebook.svg" alt="Facebook" width="24px" height="24px" />
					</a>
				</div>
			</div>
		</div>
	</div>
	<div class="nsw-footer__lower">
		<div class="nsw-container">
			<p>We pay respect to the Traditional Custodians and First Peoples of NSW, and acknowledge their continued connection to their Country and culture.</p>
			<hr>
			<ul>
				<li>
					<a target="_blank" class="footer-sub-group-item"
						[href]="ACCESSIBILITY_URL">
						Accessibility
					</a>
				</li>
				<li>
					<a target="_blank" class="footer-sub-group-item"
						[href]="COPYRIGHT_DISCLAIMER_PAGE_URL">
						Copyright and Disclaimer
					</a>
				</li>
				<li>
					<a target="_blank" class="footer-sub-group-item" [href]="PRIVACY_AND_SECURITY_URL">
						Privacy	and security
					</a>
				</li>
				<li>
					<a class="footer-sub-group-item" routerLink="/waterMonitoring/beachwatchDataFeeds">
						Data feeds
					</a>
				</li>
				<li>
					<a class="footer-sub-group-item" routerLink="/whatIsBeachwatch/contentDataSources">
						Content and data sources
					</a>
				</li>
				<li>
					<a class="footer-sub-group-item" routerLink="contactUs">
						Contact us
					</a>
				</li>
			</ul>
			<div class="nsw-footer__info">
				<div class="nsw-footer__copyright">Copyright © 2023</div>
			</div>
		</div>
	</div>
</footer>